// extracted by mini-css-extract-plugin
module.exports = {"pageDescription":"PageDescription_pageDescription__3aTVm"};